import React, { useState } from 'react';

import { ClickAwayListener } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';

import MenuItem from '@material-ui/core/MenuItem';

const OptionButtonMenu = ({ options, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => {
    isOpen && setIsOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div className="c-option-button-menu" {...props}>
        <IconButton
          aria-label="more"
          aria-controls="long-menu"
          aria-haspopup="true"
          onClick={() => setIsOpen(true)}>
          <MoreVertIcon />
        </IconButton>
        <div
          className={`
          ${isOpen ? 'c-option-button-menu__dropdown--open' : ''}
         c-option-button-menu__dropdown`}>
          {options.map((option) => (
            <MenuItem
              key={option.id}
              onClick={() => {
                setIsOpen(false);
                option.action();
              }}>
              {option.label}
            </MenuItem>
          ))}
        </div>
      </div>
    </ClickAwayListener>
  );
};

export default OptionButtonMenu;
